import React, {Component} from "react";
import "../components/payment-plans.css";
import update from 'immutability-helper';
import PaymentPlans from "../components/payment-plans";
import {toast} from "react-toastify";
import { apiFetch } from "../../apiFetch";
import PaymentPlansLayout from "../components/payment-plans-layout";

export default class ActivePaymentPlan extends Component {
  state = {
    paymentMethods: [],
    contactProvider: null
  }

  async componentDidMount() {
    const {plan, achNeedsVerification} = this.props;

    try {
      const methods = await apiFetch(`/api/fundingSources/${plan.paymentId}`, {
        method: "GET"
      });

      const paymentMethods = methods.map((pm) => {
        const needsToVerifyPM = achNeedsVerification.find(i => i.sourceId === pm.id);
        if (needsToVerifyPM) {
          return {...pm, ...needsToVerifyPM}
        }
        return pm;
      });

      this.setState({
        paymentMethods
      });
    } catch (e) {
      console.log(e);
      if (e !== 'Unauthorized') {
        toast.error('An error occured, please try again.');
      }
    }
  }

  componentDidUpdate(prevProps) {
    const {justVerifiedAccount: prev} = prevProps;
    const {justVerifiedAccount} = this.props;

    if (justVerifiedAccount && justVerifiedAccount !== prev) {
      return this.updateVerifiedAccount(justVerifiedAccount);
    }
  }

  updateVerifiedAccount(id) {
    const {paymentMethods} = this.state;
    const updatedIndex = paymentMethods.findIndex(pm => pm.id === id);
    if (updatedIndex === -1) {
      return false;
    }
    return this.setState(update(this.state, {
      paymentMethods: {
        [updatedIndex]: {
          ach_verified: {$set: 'true'}
        }
      }
    }));
  }

  getUnverifiedACH = () => {
    const {paymentMethods} = this.state;
    return paymentMethods.filter(pm => pm.object === 'bank_account' && pm.ach_verified !== 'true');
  }

  addPaymentMethod = paymentMethod => {
    this.setState({
      paymentMethods: [...this.state.paymentMethods, paymentMethod]
    });
  };


  removePaymentMethod = paymentMethodId => {
    const updatedPaymentMethods = this.state.paymentMethods.filter(
      plan => plan.id !== paymentMethodId
    );

    this.setState({paymentMethods: updatedPaymentMethods});
  };

  toggleContactsProvider = () => {
    const {contactProvider} = this.state;
    if (!contactProvider) {
      return this.showContactsProvider();
    }
    return this.hideContactProvider();
  }

  hideContactProvider = () => {
    this.setState({contactProvider: null});
  }

  showContactsProvider = async () => {
    const {plan: {paymentId}} = this.props;
    try {
      const provider = await apiFetch(`/api/payments/${paymentId}/contact_provider`, {
        method: "GET"
      });

      this.setState({contactProvider: provider});

    } catch (err) {
      console.log(err);
      toast.error('Couldn\'t retrieve contact provider information');
    }
  }


  render() {
    const {plan, showPaymentDetails, ...restProps} = this.props;
    return (
      <div>
        <PaymentPlans
          unverifiedACH={this.getUnverifiedACH()}
          plan={plan}
          showDetails={showPaymentDetails}
          paymentMethods={this.state.paymentMethods}
          {...restProps}
        />
        <PaymentPlansLayout
          {...this.state}
          currentPlan={plan}
          toggleContactsProvider={this.toggleContactsProvider}
          paymentMethods={this.state.paymentMethods}
          showDetails={showPaymentDetails}
          addPaymentMethod={this.addPaymentMethod}
          removePaymentMethod={this.removePaymentMethod}
          handleShow={this.props.handleShow}
          DeletePaymentMethod={this.props.DeletePaymentMethod}
          handleUpdateAch={this.props.handleUpdateAch}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/home/containers/active-payment-plan.js